import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { firebaseAuth } from '../firebase/auth';

/**
 * Custom hook for authentication with automatic redirect to login
 * @returns Object containing user, loading state, error, and navigate function
 */
export const useAuthRedirect = () => {
  const [user, loading, error] = useAuthState(firebaseAuth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  return { user, loading, error, navigate };
};
